import React from 'react';
import PropTypes from 'prop-types';

const SideBarProfileLogo = ({ bgColor = '#0E0E0E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6663 18.3333H14.9997V16.6666C14.9997 16.0035 14.7363 15.3677 14.2674 14.8988C13.7986 14.43 13.1627 14.1666 12.4997 14.1666H7.49967C6.83663 14.1666 6.20075 14.43 5.73191 14.8988C5.26307 15.3677 4.99967 16.0035 4.99967 16.6666V18.3333H3.33301V16.6666C3.33301 15.5615 3.77199 14.5017 4.5534 13.7203C5.3348 12.9389 6.39461 12.4999 7.49967 12.4999H12.4997C13.6047 12.4999 14.6646 12.9389 15.446 13.7203C16.2274 14.5017 16.6663 15.5615 16.6663 16.6666V18.3333ZM9.99967 10.8333C9.34306 10.8333 8.69288 10.7039 8.08626 10.4526C7.47963 10.2014 6.92843 9.83308 6.46414 9.36879C5.99985 8.90449 5.63155 8.3533 5.38028 7.74667C5.129 7.14004 4.99967 6.48986 4.99967 5.83325C4.99967 5.17664 5.129 4.52646 5.38028 3.91983C5.63155 3.31321 5.99985 2.76201 6.46414 2.29772C6.92843 1.83343 7.47963 1.46513 8.08626 1.21385C8.69288 0.962581 9.34306 0.833252 9.99967 0.833252C11.3258 0.833252 12.5975 1.36004 13.5352 2.29772C14.4729 3.2354 14.9997 4.50717 14.9997 5.83325C14.9997 7.15933 14.4729 8.4311 13.5352 9.36879C12.5975 10.3065 11.3258 10.8333 9.99967 10.8333ZM9.99967 9.16658C10.8837 9.16658 11.7316 8.8154 12.3567 8.19027C12.9818 7.56515 13.333 6.71731 13.333 5.83325C13.333 4.9492 12.9818 4.10135 12.3567 3.47623C11.7316 2.85111 10.8837 2.49992 9.99967 2.49992C9.11562 2.49992 8.26777 2.85111 7.64265 3.47623C7.01753 4.10135 6.66634 4.9492 6.66634 5.83325C6.66634 6.71731 7.01753 7.56515 7.64265 8.19027C8.26777 8.8154 9.11562 9.16658 9.99967 9.16658Z"
        fill={bgColor}
      />
    </svg>
  );
};

SideBarProfileLogo.propTypes = {
  bgColor: PropTypes.string,
};

export default SideBarProfileLogo;